// extracted by mini-css-extract-plugin
export default {"mainDivider":"styles_mainDivider__EzTI7"};